import {useMemo} from "react"
import {useIsUnitUser, useUserEmail, useIsManagedSolutionsBankingUser} from "../services/auth"
import {isProdEnv} from "../utilities/environment"
import useZendesk from "./useZendesk"
import useUnitZendesk from "./useUnitZendesk"

enum ChatBotProvider {
	Zendesk = "zendesk",
	UnitZendesk = "unitZendesk",
}

const useChatbot = () => {
	const isUnitUser = useIsUnitUser()
	const isProd = isProdEnv()
	const userEmail = useUserEmail()
	const isManagedSolutionsBankingUser = useIsManagedSolutionsBankingUser()

	const currentProvider = useMemo((): ChatBotProvider | null => {
		// Don't show support widget for RTL users
		if (isManagedSolutionsBankingUser) {
			return null
		}

		// Unit users in sandbox or local env get the unitfinanceai Zendesk widget
		if (!isProd && (isUnitUser || userEmail.endsWith("unit.co"))) {
			return ChatBotProvider.UnitZendesk
		}

		// In other cases, we use the customer Zendesk widget
		return ChatBotProvider.Zendesk
	}, [isUnitUser, isProd, userEmail, isManagedSolutionsBankingUser])

	useZendesk(currentProvider === ChatBotProvider.Zendesk)
	useUnitZendesk(currentProvider === ChatBotProvider.UnitZendesk)
}

export default useChatbot
